import { CameraAlt, Diversity3, People } from '@mui/icons-material';
import { Button, Grid, Typography, alpha } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { Link } from 'react-router-dom';
import React from 'react';

interface Report {
  label: string;
  description: string;
  route: RoutesEnum;
  icon: React.ElementType;
}

export const ReportPicker = () => {
  const { t } = useTranslation();

  const reports: Report[] = [
    {
      label: t('statistics:report.snapshot'),
      description: t('statistics:report.snapshotDescription'),
      route: RoutesEnum.StatisticsReportsSnapshot,
      icon: CameraAlt,
    },
    {
      label: t('statistics:report.membersCount'),
      description: t('statistics:report.membersCountDescription'),
      route: RoutesEnum.StatisticsReportsMembers,
      icon: People,
    },
    {
      label: t('statistics:report.ageAndGenderDistribution'),
      description: t('statistics:report.ageAndGenderDistributionDescription'),
      route: RoutesEnum.StatisticsAgeAndGenderDistribution,
      icon: Diversity3,
    },
  ];

  return (
    <>
      <GridWrapper>
        {reports.map((rep) => (
          <Grid item xs={12} md={6} lg={4} key={rep.route}>
            <Button
              component={Link}
              to={rep.route}
              color='primary'
              variant='outlined'
              fullWidth
              sx={{
                py: 2,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'row',
                height: '100%',
                backgroundColor: '#fff',
                position: 'relative',
                '&:hover': {
                  backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                },
                '&.selected': {
                  borderWidth: 3,
                  backgroundColor: (theme) => alpha(theme.palette.success.light, 0.2),
                },
              }}
            >
              <Box mr={1}>
                <rep.icon sx={{ width: '2rem', opacity: 0.8 }} />
              </Box>

              <Box>
                <Typography
                  variant='body1'
                  component='div'
                  sx={{
                    fontWeight: 550,
                    textTransform: 'none',
                    textAlign: 'left',
                  }}
                >
                  {t(rep.label)}
                </Typography>
                <Typography
                  variant='body2'
                  component='div'
                  sx={{
                    fontWeight: 100,
                    textTransform: 'none',
                    textAlign: 'left',
                    mt: 1,
                  }}
                >
                  {t(rep.description)}
                </Typography>
              </Box>
            </Button>
          </Grid>
        ))}
      </GridWrapper>
    </>
  );
};
